import styled from "styled-components";

import { theme } from "../../configuration";

const HelpResultIcon = styled.div`
  width: 64px;
  height: 64px;
  
  @media (max-width: ${theme.pageWidthForSingleColumnHelpResults}) {
    height: 30px;
    width: 30px;
    margin-right: 15px;
  }
`;

export default HelpResultIcon;
